import React from 'react';
import MarketingSidebar from './MarketingSidebar';
import MarketingHeader from './MarketingHeader';

function MarketingLayout({ children }) {
  return (
    <div className="mkt-layout">
      <MarketingSidebar />
      <div className="mkt-main">
        <MarketingHeader />
        <div className="mkt-content">
          {children}
        </div>
      </div>
    </div>
  );
}

export default MarketingLayout;
